var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticStyle:{"text-align":"center"},attrs:{"show":_vm.errorLoadingData,"variant":"danger"}},[_vm._v(" Sorry we are unable to fetch the required information at this time."),_c('br'),_vm._v(" If this continues then please contact your local Travel Centre"),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.branchNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }